<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6 class="mb-0">Comunicado à família</h6>
        <i class="bi bi-x-circle close-icon" @click="fechar"></i>
      </div>

      <!-- Conteúdo -->
      <div class="modal-content">
        <ul class="list-unstyled mb-3">
          <li><strong>Aluno(a):</strong> {{ queda.aluno }}</li>
          <li>
            <strong>Responsável:</strong> {{ queda.responsavel }}
            <span v-if="queda.responsavel_telefone">– Tel: {{ formatarTelefoneComDdi(queda.responsavel_telefone, queda.responsavel_telefone_ddi) }}</span>
            <span v-if="queda.responsavel_celular">– Cel: {{ formatarTelefoneComDdi(queda.responsavel_celular, queda.responsavel_celular_ddi) }}</span>
          </li>
          <li><strong>Data da queda:</strong> {{ formatarData(queda.data_queda) }}</li>
          <li><strong>Turma:</strong> {{ queda.turma }}</li>
          <li><strong>Instrutor:</strong> {{ queda.instrutor }}</li>
          <li><strong>Animal:</strong> {{ queda.animal }}</li>
        </ul>

        <div class="form-group mb-2">
          <label>Relato do instrutor</label>
          <textarea
            class="form-control"
            rows="6"
            style="min-height: 100px;"
            :value="queda.observacoes"
            disabled
          ></textarea>
        </div>

        <div class="form-group mb-2">
          <label>Descreva o comunicado à família <span class="required">*</span></label>
          <textarea
            v-model="form.descricao"
            class="form-control"
            rows="6"
           style="min-height: 100px;"

            required
          ></textarea>
        </div>
      </div>

      <!-- Rodapé -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="fechar">Cancelar</button>
        <button
          class="btn btn-primary"
          :disabled="!form.descricao || isSubmitting"
          @click="salvar"
        >
          {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils';

const instance = getCurrentInstance();
const gs = instance.appContext.config.globalProperties.$globalState;
const userName = gs.userName;


const props = defineProps({
  mostrar: { type: Boolean, default: false },
  queda:   { type: Object, required: true },
});
const emit = defineEmits(['close','salvou']);

const form = ref({ descricao: '' });
const isSubmitting = ref(false);

watch(() => props.queda, q => {
  form.value.descricao = q.descricao || '';
}, { immediate: true });

function fechar() {
  emit('close');
}

function formatarTelefoneComDdi(numero, ddi = '') {
  const n = String(numero || '').trim();
  if (!n) return '';

  // Se o número já foi salvo com DDI no próprio texto, não duplica.
  if (/^\+\d/.test(n)) return n;

  const d = String(ddi || '').trim() || '+55';

  return `${d} ${n}`.trim();
}

function formatarData(dt) {
  return globalUtils.formatarData(dt);
}

async function salvar() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    await axios.patch(`/operacional/quedas/${props.queda.id}`, {
      descricao: form.value.descricao,
      por:       userName
    });
    emit('salvou');
    fechar();
  } catch (err) {
    console.error('Erro ao salvar comunicação:', err);
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 500px;
}
.modal-header {
  background: #ccc;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-content {
  padding: 15px;
}
.modal-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.required {
  color: red;
}
.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
</style>
